import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import BlockUi from "react-block-ui";
import { Form } from "react-bootstrap";
import InputMask from "react-input-mask";
import { useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import styled from "styled-components";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { customSelectStyle } from "../../../../_metronic/_partials/dropdowns/ReactSelectCustomStyle";
import { normalizeAmount } from "../../../helpers/normalizeAmount";
import RefundInfo from "./RefundInfo";
import { haveToShowRefundInfo } from "../../../helpers/refund";
import { shouldUsePlanOffers } from "../../../services/subscriptionPlanOffers";

const IMAGE_DEFAULT_CREDIT_CARD =
  "data:image/svg+xml;base64,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";

const Content = styled.div`
  input:focus {
    border: 1px solid #41c78f !important;
  }

  span.title {
    color: #2e3f75;
    font-weight: bold;
    font-size: 21px;
  }
  h3 {
    color: #2e3f75;
    font-size: 22px;
    display: inline-block;
  }
  p {
    width: 70%;
    text-align: left;
    color: #2e3f75;
    opacity: 0.6;
    margin-top: 5px;
    margin-bottom: 15px;
  }
  span.price {
    font-size: 30px;
    text-align: right;
    display: inline-block;
    float: right;
    margin-top: -68px;
  }
  span.desc-payment {
    font-weight: normal;
    font-size: 12px;
    width: 61%;
    display: inline-block;
    margin-top: 20px;
  }
  hr {
    opacity: 0.1;
    margin: 10px 0px 20px 0px;
  }

  label:not(.invalid-feedback) {
    margin: 0;
    padding: 0;
    font-size: 13px;
    opacity: 0.6;
    color: #091d5c;
    margin: 10px 0px;
  }
  input.form-control {
    margin: 0;
    padding: 9px;
    outline: none;
    box-shadow: none;
    border: 1px solid #ccc;
  }

  .btn-primary {
    background: #41c78f;
    border: none;
    display: inline-block;
    border-radius: 50px;
    padding: 12px 40px;
    font-size: 16px;
    text-transform: uppercase;
    font-weight: 600;
    margin-top: 13px;
    float: right;
  }
  .btn-primary:hover {
    cursor: pointer;
    background: #3ab380;
  }

  @media only screen and (max-width: 899px) {
    .row {
      margin-top: 0px;
    }
    hr {
      margin: 10px;
    }
    label {
      margin: 5px 0px;
    }
    span {
      font-size: 16px;
    }
    h3 {
      font-size: 14px;
    }
    p {
      font-size: 12px;
      width: 100%;
    }

    span.price {
      float: none;
      margin: 0 auto;
      text-align: center;
      letter-spacing: -0.9;
    }
    input.form-control {
      width: 100%;
      margin-bottom: 10px;
      padding: 4px;
    }
    span.desc-payment {
      width: 100%;
      margin-top: 0;
      opacity: 0.6;
      font-size: 10px;
    }

    .btn-primary {
      padding: 10px 40px;
      font-size: 14px;
      width: 100%;
      margin-top: 10px;
    }
  }
`;

const ButtonBack = styled.img`
  filter: brightness(0) saturate(100%) invert(58%) sepia(59%) saturate(452%)
    hue-rotate(103deg) brightness(92%) contrast(83%);
  cursor: pointer;
  margin: 0 5px 5px 0;
`;

const CreditCardContainer = styled.div`
  position: relative;

  img {
    height: 23px;
    position: absolute;
    right: 9px;
    top: 8px;
  }
`;

export default function Checkout(props) {
  const current_subscription = useSelector(state => state.app.client_subscription);
  const clientPlanOffers = useSelector(state => state.app.client_plan_offers);
  const loadedCards = useSelector(state => state.app.cards);
  const [plans, setPlans] = useState([]);
  const [isValidToCheckout, setIsValidToCheckout] = useState(false);


  const checkout = () => {
    props.formik.handleSubmit();
  };

  const getSvgCreditCard = card_payment_method => {
    const payment_methods_relation = [
      { id: "master", svg: "/media/svg/credit-card/flat/mastercard.svg" },
      { id: "visa", svg: "/media/svg/credit-card/flat/visa.svg" },
      { id: "amex", svg: "/media/svg/credit-card/flat/amex.svg" },
      { id: "hipercard", svg: "/media/svg/credit-card/flat/hipercard.svg" },
      { id: "elo", svg: "/media/svg/credit-card/flat/elo.svg" }
    ];

    const relation = payment_methods_relation.filter(
      relation => relation.id === card_payment_method.id
    );
    if (relation[0]) {
      return toAbsoluteUrl(relation[0].svg);
    }

    return card_payment_method.thumbnail;
  };

  const getPlans = async () => {
    if (shouldUsePlanOffers(clientPlanOffers)) {
      setPlans(clientPlanOffers);
      return;
    }

    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "/subscription/plans_admin"
      );
      if (response.data && response.data.plans) {
        setPlans(response.data.plans);
      }
    } catch (err) {
      toast.error("Ocorreu um erro ao carregar os planos.");
    }
  };

  const cards = useMemo(() => {
    if (
      props?.migrationData?.enableOrganicMigration || 
      props?.migrationData?.cards?.length > 0
    ) {
      const migrationCards = props?.migrationData?.cards?.filter(card => card.valid) || [];
      return migrationCards.map(mc => ({
        ...mc,
        hash: mc.provider_id,
        expiration_date: `${mc?.expiration_month ?? "00"}/${mc?.expiration_year ?? "00"}`,
        id: mc.id,
        brand: mc.brand,
        last_digits: mc.digits,
        in_use: mc.is_primary,
        valid: mc.valid,
      }));
    }

    return loadedCards;
  }, [loadedCards, props?.migrationData?.cards, props?.migrationData?.enableOrganicMigration]);

  useEffect(() => {
    getPlans();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientPlanOffers]);

  useEffect(() => {
    if (props.formik.values.plan_id || props.formik.values.card_selected) {
      handleValidateCheckout();
    }
  }, [props.formik.values.plan_id, props.formik.values.card_selected]);

  const handleValidateCheckout = () => {
    const plan = props.formik.values.plan_id;
    const isBankslipSelected = props.formik.values.card_selected === "boleto";
    const minValidAmount = 500;

    if (isBankslipSelected && plan) {
      const amount = normalizeAmount(plan.amount);

      if (amount === 0) {
        toast.error(
          "Erro ao processar o valor do plano. Verifique se o valor está correto."
        );
        props.formik.setFieldError("plan_id", "Valor do plano inválido.");
        setIsValidToCheckout(false);
        return;
      }
      if (amount < minValidAmount) {
        toast.error(
          `Não foi possível realizar a operação. Valor mínimo permitido para boletos: 
          R$${(minValidAmount / 100).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
        );
        props.formik.setFieldError(
          "plan_id",
          "O valor do plano está abaixo do mínimo permitido para boletos."
        );
        setIsValidToCheckout(false);
        return;
      }
    }
    props.formik.setFieldError("plan_id", undefined);
    setIsValidToCheckout(true);
  };

  const showRefundInfo = haveToShowRefundInfo(current_subscription?.info);

  return (
    <BlockUi tag="div" blocking={props.formik.isSubmitting}>
      <Content>
        {props.back && (
          <ButtonBack
            onClick={() => props.back()}
            src={toAbsoluteUrl("/media/svg/icons/Navigation/Arrow-left.svg")}
          />
        )}
        <span className="title">
          {props.migrationData?.enableOrganicMigration
            ? "Migração PSP 1.0 para 2.0"
            : "Checkout PSP 2.0"}
        </span>
        <hr />
        <label className="form-label mb-0">Plano</label>
        <Select
          name="plan_id"
          theme={customSelectStyle}
          options={plans}
          onChange={value => {
            props.formik.setFieldValue("plan_id", value);
          }}
          value={props.formik.values.plan_id}
          placeholder="Selecione.."
          className={
            props.formik.errors.plan_id && props.formik.touched.plan_id
              ? "is-invalid"
              : ""
          }
          getOptionLabel={option => option.name}
          getOptionValue={option => option.id}
          isClearable={false}
          noOptionsMessage={() => <span>Sem resultados.</span>}
        />
        {props.formik.errors.plan_id && props.formik.touched.plan_id && (
          <label className="invalid-feedback">
            {props.formik.errors.plan_id}
          </label>
        )}

        <div className="hr mt-5"></div>

        <div key={props.formik.values.card_selected} className="mb-3">
          <Form.Check
            custom
            type={"checkbox"}
            label={"Boleto/PIX"}
            checked={props.formik.values.card_selected === "boleto"}
            onChange={() => {
              props.formik.setFieldValue("card_selected", "boleto");
            }}
            id={"boleto"}
          />

          {cards &&
            cards.map(card => (
              <Form.Check
                custom
                type={"checkbox"}
                label={`Cartão com final ${card.last_digits}`}
                checked={
                  props.formik.values.card_selected &&
                  props.formik.values.card_selected.hash === card.hash
                }
                onChange={() => {
                  props.formik.setFieldValue("card_selected", card);
                }}
                id={`card-${card.hash}`}
              />
            ))}
          <Form.Check
            custom
            type={"checkbox"}
            label={"Desejo informar os dados do cartão manualmente"}
            checked={props.formik.values.card_selected === null}
            onChange={() => {
              props.formik.setFieldValue("card_selected", null);
            }}
            id={"card-none"}
          />
        </div>

        {props.formik.values.card_selected === null && (
          <div className="row">
            <div className="col-12">
              <label>Nome impresso no cartão</label>
              <input
                name="cardholder_name"
                type="text"
                className={
                  "form-control " +
                  (props.formik.errors.cardholder_name &&
                  props.formik.touched.cardholder_name
                    ? "is-invalid"
                    : "")
                }
                onChange={props.formik.handleChange}
                value={props.formik.values.cardholder_name}
              />
              {props.formik.errors.cardholder_name &&
                props.formik.touched.cardholder_name && (
                <label className="invalid-feedback">
                  {props.formik.errors.cardholder_name}
                </label>
              )}
            </div>
            <div className="col-lg-6">
              <label>Número do cartão</label>
              <CreditCardContainer>
                <InputMask
                  name="card_number"
                  placeholder="0000 0000 0000 0000"
                  mask="9999 9999 9999 9999"
                  maskChar={null}
                  className={
                    "form-control " +
                    (props.formik.errors.card_number &&
                    props.formik.touched.card_number
                      ? "is-invalid"
                      : "")
                  }
                  type="tel"
                  onChange={props.formik.handleChange}
                  value={props.formik.values.card_number}
                />
                {props.formik.values.card_payment_method != null && (
                  <img
                    src={getSvgCreditCard(
                      props.formik.values.card_payment_method
                    )}
                    alt="Bandeira do cartão"
                  />
                )}
                {props.formik.values.card_payment_method == null && (
                  <img src={IMAGE_DEFAULT_CREDIT_CARD} alt="Bandeira padrão" />
                )}
                {props.formik.errors.card_number &&
                  props.formik.touched.card_number && (
                  <label className="invalid-feedback">
                    {props.formik.errors.card_number}
                  </label>
                )}
              </CreditCardContainer>
            </div>

            <div className="col-lg-3 col-6">
              <label>Vencimento</label>
              <InputMask
                name="card_expiration"
                placeholder="MM / AA"
                mask="99 / 99"
                maskChar={null}
                className={
                  "form-control " +
                  (props.formik.errors.card_expiration &&
                  props.formik.touched.card_expiration
                    ? "is-invalid"
                    : "")
                }
                type="tel"
                onChange={props.formik.handleChange}
                value={props.formik.values.card_expiration}
              />
              {props.formik.errors.card_expiration &&
                props.formik.touched.card_expiration && (
                <label className="invalid-feedback">
                  {props.formik.errors.card_expiration}
                </label>
              )}
            </div>

            <div className="col-lg-3 col-6">
              <label>CVV</label>
              <InputMask
                name="card_cvv"
                placeholder="000"
                mask="9999"
                maskChar={null}
                className={
                  "form-control " +
                  (props.formik.errors.card_cvv && props.formik.touched.card_cvv
                    ? "is-invalid"
                    : "")
                }
                type="tel"
                onChange={props.formik.handleChange}
                value={props.formik.values.card_cvv}
              />
              {props.formik.errors.card_cvv &&
                props.formik.touched.card_cvv && (
                <label className="invalid-feedback">
                  {props.formik.errors.card_cvv}
                </label>
              )}
            </div>
          </div>
        )}

        <RefundInfo
          show={showRefundInfo}
          plans={plans}
          selectedPlanId={props.formik.values.plan_id?.id}
        />

        <span className="desc-payment">&nbsp;</span>
        <button
          className="btn btn-primary"
          type="button"
          onClick={checkout}
          disabled={props.formik.isSubmitting || !isValidToCheckout}
        >
          {props.formik.isSubmitting ? "Assinando..." : "Assinar agora"}
        </button>
      </Content>
    </BlockUi>
  );
}
